@if (product) {
  <div class="product-item">
    <a
      (click)="toggleAutocomplete.emit()"
      class="product-item__img"
      [sRouterLink]="['product', productUrl]"
      [title]="productName"
    >
      <img loading="lazy" [src]="product.image" [alt]="productName" />
    </a>
    <a
      (click)="toggleAutocomplete.emit()"
      [sRouterLink]="['product', productUrl]"
      class="product-item__name"
    >
      {{ productName }}
    </a>
    <span class="product-item__info">
      {{ 'Product code' | translate | async }}: {{ product.sku }}
    </span>
    <div class="product-item__price">
      <app-currency></app-currency>
      <app-price [price]="product.finalPrice"></app-price>
    </div>
    <div class="product-item__desc" [innerHTML]="product.short_description"></div>
    <app-speedy-qty
      class="product-item__qty"
      [qty]="qty"
      [fullWidth]="true"
      (qtyChange)="changeQty(qty)"
    ></app-speedy-qty>
    <app-speedy-button
      [loadingSuccess]="loadingSuccess"
      [loading]="loading"
      text="Add to cart"
      (clicked)="addToCart(product)"
    ></app-speedy-button>
  </div>
}
